import PropTypes from 'prop-types';

export default function OrgaOnly({ event, children }) {
    if (event) {
        return null;
    }

    return children;
}

OrgaOnly.defaultProps = {
    event: null
};

OrgaOnly.propTypes = {
    event: PropTypes.object,
    children: PropTypes.node
};
